import { theme as defaultTheme } from "@mindlercare/ui-web";
import { createGlobalStyle } from "styled-components";
import { MUIOverrides, reactPhoneInputOverrides } from "./library-overrides";

export const GlobalStyle = createGlobalStyle`

html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

body, html, #root, #main {
  height: 100%;
}

  * {
      box-sizing: border-box;
  }

  p, h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }


    body {
        font-family: ${(p) => defaultTheme.FONT.FAMILY.BODY};
        font-size: 16px;
        margin: 0;
        overflow: hidden;
        font-feature-settings: "cv01", "cv11";
    }

    p {
      line-height: 1.5
    }


    ${reactPhoneInputOverrides}

    ${MUIOverrides}
`;
